import BadgeDetailLayout from '@/layouts/BadgeDetail';
import BadgeDetailMembers from '@/screens/BadgeDetail/BadgeDetailMembers';

export default function PrivateTabsOrganizationBadgeBadgeIdIndexRoute() {
  return (
    <BadgeDetailLayout>
      <BadgeDetailMembers />
    </BadgeDetailLayout>
  );
}
